import type { ClientType } from "store/types/user-management";

/** Human-readable label for each client `type`. */
export const clientTypeLabels: Record<ClientType, string> = {
  individual: "Individual",
  family_household: "Family / Household",
  trust: "Trust",
  foundation: "Foundation",
  company_holding: "Company / Holding",
  partnership: "Partnership",
  spv_investment_vehicle: "SPV / Investment Vehicle",
  fund: "Fund",
  estate: "Estate",
  charity_nonprofit: "Charity / Non-profit",
  other: "Other"
};

/** Option list for client-type selectors (Add drawer, Filters). */
export const clientTypeOptions: { label: string; value: ClientType }[] = (
  Object.entries(clientTypeLabels) as [ClientType, string][]
).map(([value, label]) => ({ value, label }));

/** Resolve a client type to its label; returns null when unset so the caller can render a placeholder. */
export const getClientTypeLabel = (type?: ClientType | null): string | null =>
  type ? clientTypeLabels[type] ?? type : null;
